import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBeatDeleteIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	role: "img",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 4.25832H16M7.5 12.4642V7.99167M10.5 12.4642V7.99167M10.5 1.74023H7.5C6.948 1.74023 6.5 2.18823 6.5 2.74023V4.25832H11.5V2.74023C11.5 2.18823 11.052 1.74023 10.5 1.74023ZM13.5767 15.341C13.5333 15.8597 13.1 16.2583 12.58 16.2583H5.42067C4.90067 16.2583 4.46733 15.8597 4.424 15.341L3.5 4.25832H14.5L13.5767 15.341Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBeatDeleteIcon;
